import gql from "graphql-tag";
import { Company } from "../baseTypes";
export default gql`
  query GetCompanyLocations(
    $id: ID!
    $name: String
    $locationId: ID
    $limit: Int
    $nextToken: String
  ) {
    getCompany(id: $id) {
      id
      settings {
        hasSelfTests
        defaultSelfTests
      }
      name
      deactivated
      locations(
        limit: $limit
        nextToken: $nextToken
        filter: {
          and: [
            {
              or: [
                { name: { contains: $name } }
                { locationId: { contains: $locationId } }
              ]
            }
            { deactivated: { ne: true } }
          ]
        }
      ) {
        items {
          name
          id
          companyId
          locationId
          address {
            street
            number
            city
            zip
            country
          }
          phone
          email
          healthDepartmentEmail
          healthDeparmentNumber
          enableAutoEmail
          deactivated
        }
        nextToken
      }
    }
  }
`;
export interface GetCompanyLocationsQuery {
  getCompany: Company | null;
}
